import { useQuery } from '@tanstack/react-query';

import CruiseIqService, { type RelationshipData } from '~/services/cruises/CruiseIqService';

export const cruiseIqRelationshipKeys = {
  all: ['cruise-iq', 'relationships'] as const,
  byVendor: (vendorId: string) => [...cruiseIqRelationshipKeys.all, vendorId] as const,
  byVendorAndOffers: (vendorId: string, offerIds?: Array<string>) =>
    [...cruiseIqRelationshipKeys.byVendor(vendorId), offerIds?.join(',') ?? 'all'] as const,
};

export function useGetCruiseIqRelationships(vendorId: string, offerIds?: Array<string>) {
  return useQuery<RelationshipData>({
    queryKey: cruiseIqRelationshipKeys.byVendorAndOffers(vendorId, offerIds),
    queryFn: () => CruiseIqService.getRelationships(vendorId, offerIds),
    enabled: !!vendorId,
  });
}
